/* Videos de "Aprende con Aili" en la home: fachada propia, YouTube solo al pulsar
   (27-sep-2026; opción B elegida por Andrés: una destacada y dos filas).

   El bloque custom_liquid `hai_aprende_aili` (templates/index.json) imprime tres
   tarjetas .hai-video con la MISMA estructura de datos: data-hai-video (id de
   YouTube), .hai-video__img (póster), __titulo, __meta, __dur y un enlace
   .hai-video__btn a youtube.com/watch (sin JS, el clic abre YouTube en otra
   pestaña: nunca queda muerto). La destacada (.hai-video--destacado) es el ÚNICO
   reproductor, como una lista de reproducción: al pulsarla se crea un iframe de
   youtube-nocookie con autoplay dentro de su marco; al pulsar una fila, los datos
   de la fila y de la destacada se intercambian y la destacada reproduce el video
   elegido (la fila pasa a mostrar el que estaba destacado). Antes del clic la home
   no carga nada de YouTube: solo tres JPG del tema. Lo carga el propio bloque con
   <script defer>, así que corre únicamente donde existe el bloque. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-hai-videos]');
  if (!raiz) return;

  var CAMPOS = ['titulo', 'meta', 'dur'];

  function nodo(art, clase) {
    return art.querySelector('.hai-video__' + clase);
  }

  function leer(art) {
    var d = { id: art.getAttribute('data-hai-video'), src: nodo(art, 'img').getAttribute('src') };
    CAMPOS.forEach(function (c) { d[c] = nodo(art, c).textContent; });
    return d;
  }

  function poner(art, d) {
    art.setAttribute('data-hai-video', d.id);
    nodo(art, 'img').setAttribute('src', d.src);
    CAMPOS.forEach(function (c) { nodo(art, c).textContent = d[c]; });
    var enlace = nodo(art, 'btn');
    enlace.setAttribute('href', 'https://www.youtube.com/watch?v=' + d.id);
    enlace.setAttribute('aria-label', 'Reproducir: ' + d.titulo);
  }

  function reproducir(art) {
    var marco = nodo(art, 'marco');
    var iframe = marco.querySelector('iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.className = 'hai-video__iframe';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      marco.appendChild(iframe);
    }
    iframe.title = nodo(art, 'titulo').textContent;
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + art.getAttribute('data-hai-video') + '?autoplay=1&rel=0&playsinline=1';
    art.classList.add('hai-video--reproduciendo');
  }

  raiz.addEventListener('click', function (e) {
    var enlace = e.target.closest('.hai-video__btn');
    // Con modificadores (ctrl, cmd, shift) se respeta el enlace: abre YouTube aparte.
    if (!enlace || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var art = enlace.closest('.hai-video');
    var destacado = raiz.querySelector('.hai-video--destacado');
    if (!art || !destacado) return;
    e.preventDefault();
    if (art !== destacado) {
      var elegido = leer(art);
      var anterior = leer(destacado);
      poner(destacado, elegido);
      poner(art, anterior);
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destacado.scrollIntoView({ block: 'nearest', behavior: suave ? 'smooth' : 'auto' });
    }
    reproducir(destacado);
  });
})();
